const _isEqual = (arr) => {
  return arr.every( v => v === arr[0]);
};

const _deepClone = (inObject) => {
  let outObject, value, key;

  if (typeof inObject !== "object" || inObject === null) {
    return inObject;
  }

  outObject = Array.isArray(inObject) ? [] : {};

  for (key in inObject) {
    value = inObject[key];

    outObject[key] = _deepClone(value);
  }

  return outObject;
};

const _getUrlParams = (url) => {
  return {
    ids: url.searchParams.get('ids'),
    base64: url.searchParams.get('b')
  }
};

const writeProductsToStorage = categories => {
  if (typeof aStorage === 'undefined') return;
  const ids = []
  if(categories && Object.keys(categories).length > 0){
    for(const key in categories){
      if(categories[key].items && Object.keys(categories[key].items).length > 0){
        for(const item in categories[key].items){
          ids.push(categories[key].items[item].id)
        }
      }
    }
  }
  aStorage.set('compare_items', ids.join(','))
}

const _pluralize = (count, words) => {
  const cases = [2, 0, 1, 1, 1, 2];
  return words[
      count % 100 > 4 && count % 100 < 20 ? 2 : cases[Math.min(count % 10, 5)]
      ];
};

export { _isEqual, _deepClone, _getUrlParams, writeProductsToStorage, _pluralize };
